import Marquee from "react-fast-marquee";
import { SeedMark } from "./SeedMark";

const items = [
  "Imóveis Urbanos",
  "Imóveis Rurais",
  "Compra & Venda",
  "Avaliação de Imóveis",
  "Consultoria Imobiliária",
  "Facilitando Conquistas",
];

export const MarqueeRibbon = () => (
  <div
    className="border-y border-seed-deep/10 py-5"
    style={{ background: "rgba(26,168,134,0.10)" }}
    data-testid="marquee-ribbon"
  >
    <Marquee speed={40} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <div key={i} className="flex items-center gap-8 pr-8">
          <span className="font-heading text-sm font-semibold uppercase tracking-[0.3em] text-seed-deep">
            {item}
          </span>
          <SeedMark size={14} />
        </div>
      ))}
    </Marquee>
  </div>
);
